module.exports = __webpack_public_path__ + "img/products-md.2d8887e7.png";